import { motion } from "motion/react";

function getStockStyle(remainingStock) {
  if (remainingStock <= 2) {
    return {
      bar: "bg-red-600",
      text: "text-red-600",
    };
  }

  if (remainingStock <= 6) {
    return {
      bar: "bg-orange-500",
      text: "text-orange-600",
    };
  }

  return {
    bar: "bg-emerald-500",
    text: "text-emerald-600",
  };
}

export default function FlashDealProgress({
  remainingStock,
  totalStock,
}) {
  const percentage = Math.max(
    0,
    Math.min(
      100,
      (Number(remainingStock || 0) / Number(totalStock || 1)) * 100
    )
  );

  const stockStyle = getStockStyle(remainingStock);

  return (
    <div>
      <div className="flex items-center justify-between gap-3">
        <span className={`text-xs font-black ${stockStyle.text}`}>
          {remainingStock} {remainingStock === 1 ? "item" : "items"} left
        </span>

        <span className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          Selling fast
        </span>
      </div>

      <div className="mt-2 h-2 overflow-hidden rounded-full bg-neutral-100">
        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: `${percentage}%` }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className={`h-full rounded-full ${stockStyle.bar}`}
        />
      </div>
    </div>
  );
}